export default __webpack_public_path__ + "static/The Home_image 3@2x-18b715d654771d049bc5649abd257999.jpg";